import React from "react"
import PropTypes from "prop-types"
import {Box, Typography} from "@mui/material"
import FormSectionAccordion from "../../../../components/FormSectionAccordion"
import ButtonWithIcon from "../../../../components/Button/Button"
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline"
import {ReactComponent as CheckIcon} from "../../../../assets/icons/check-icon.svg"
import theme from "../../../../theme/theme"
import {renderGrid} from "../../../../components/FieldRenderer"
import {ofertaFields, ofertaRadios, publicoAlvoRadios, publicoDatas, coordenadoresFields} from "./constants"
import {verifyOcr} from "../../utils/info-section-constants"

const OfertaSection = ({
                           state,
                           ocr = false,
                           ocrState,
                           setSectionField,
                           isValid,
                           showError,
                           actions,
                           defaultOpen = false,
                           syncToken = 0,
                           autoCompleteController = {},
                           onRegisterEmpresa,
                       }) => {
    return (
        <FormSectionAccordion
            title="Oferta"
            icon={<CheckIcon style={{color: theme.palette.icon.main, width: 20, height: 20}}/>}
            isValid={isValid}
            showError={showError}
            actions={actions}
            defaultOpen={defaultOpen}
            syncToken={syncToken}
        >
            {renderGrid(
                ocr ? verifyOcr(ocr, ocrState, ofertaFields) : ofertaFields,
                state,
                (key) => (value) => setSectionField("oferta", key, value),
                undefined,
                undefined,
                (key, value) => setSectionField("oferta", key, value),
                autoCompleteController
            )}

            <Box sx={{mt: 1}}>
                {renderGrid(
                    ofertaRadios,
                    state,
                    (key) => (value) => setSectionField("oferta", key, value)
                )}
            </Box>

            <Box sx={{mt: 4}}>
                <Typography variant="h3" color="common.white" sx={{mb: 2}}>
                    Público-Alvo
                </Typography>
                {renderGrid(
                    ocr ? verifyOcr(ocr, ocrState, publicoAlvoRadios) : publicoAlvoRadios,
                    state,
                    (key) => (value) => setSectionField("oferta", key, value),
                    undefined,
                    {spacing: 2}
                )}
                <Box sx={{mt: 4}}>
                    {renderGrid(
                        ocr ? verifyOcr(ocr, ocrState, publicoDatas) : publicoDatas,
                        state,
                        (key) => (value) => setSectionField("oferta", key, value)
                    )}
                </Box>
            </Box>
            <Box sx={{mt: 4}}>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        mb: 3,
                    }}
                >
                    <Typography variant="h3" color="common.white">
                        Coordenadores
                    </Typography>
                    <ButtonWithIcon size="md" icon={<AddCircleOutlineIcon/>} onClick={onRegisterEmpresa}>
                        CADASTRAR COORDENADOR
                    </ButtonWithIcon>
                </Box>
                {renderGrid(
                    ocr ? verifyOcr(ocr, ocrState, coordenadoresFields) : coordenadoresFields,
                    state,
                    (key) => (value) => setSectionField("oferta", key, value),
                    undefined,
                    {spacing: 2},
                    (key, value) => setSectionField("oferta", key, value),
                    autoCompleteController
                )}
            </Box>
        </FormSectionAccordion>
    )
}

OfertaSection.propTypes = {
    state: PropTypes.object.isRequired,
    ocr: PropTypes.bool,
    ocrState: PropTypes.object,
    setSectionField: PropTypes.func.isRequired,
    isValid: PropTypes.bool,
    showError: PropTypes.bool,
    actions: PropTypes.node,
    defaultOpen: PropTypes.bool,
    syncToken: PropTypes.number,
    autoCompleteController: PropTypes.object,
    onRegisterEmpresa: PropTypes.func,
}

export default OfertaSection
